import { render } from "./ListeAttenteDescription.vue?vue&type=template&id=1f612f8a"
import script from "./ListeAttenteDescription.vue?vue&type=script&lang=js"
export * from "./ListeAttenteDescription.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__